var map = {
	"./HoennMaps.json": [
		1724,
		866
	],
	"./Johto4Maps.json": [
		9438,
		458
	],
	"./JohtoMaps.json": [
		2970,
		761
	],
	"./Kanto3Maps.json": [
		8851,
		38
	],
	"./KantoMaps.json": [
		2983,
		151
	],
	"./SinnohMaps.json": [
		5693,
		654
	],
	"./Unova2Maps.json": [
		9182,
		649
	],
	"./UnovaMaps.json": [
		3045,
		680
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6959;
module.exports = webpackAsyncContext;